import { Address, isAddressEqual } from 'viem';

export const ETHER = '1e18';

export const HUMAN_DECIMALS = 8;
export const PRECISE_DECIMALS = 18;

export const HUMAN_DECIMALS_PERCENT = 1;
export const PRECISE_DECIMALS_PERCENT = 5;

export const HUMAN_DECIMALS_CURRENCY = 3;
export const PRECISE_DECIMALS_CURRENCY = 6;

export const zeroAddress = '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE';

export const isNative = (address: string | Address) => isAddressEqual(address as Address, zeroAddress);
